/**
 * 문자 수신내역 — 은행 입출금 문자 (/adm/sms-recv)
 * ($j.Pages.Admin.SmsRecv / body data-page-name="SmsRecv")
 *
 * 입금·출금·기타 탭별 문자 목록. 입금 문자 중 처리 안 된 것은 [처리] → 회원을 골라 캐시 충전.
 * 화면 상태(currentTab·$table)는 모듈 안에만 있다 — window 에 함수를 내놓지 않는다.
 */
export default class SmsRecv {
    initialize() {
        initPage();
        initHandler();
    }
}

let $table = null;
let currentTab = 1;
const tabMsgMap = {
    1 : '입금',
    2 : '출금',
    3 : '기타',
};


function initPage(){
    const d1 = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
    const d2 = dayjs().format('YYYY-MM-DD');

    $('#start_date').val(d1);
    $('#end_date').val(d2);

    setActiveTabStyle();
    loadTable();
}

function initHandler(){
    $('#start_date, #end_date').mobiscroll().datepicker({
        controls: ['calendar'],
        dateFormat: 'YYYY-MM-DD',
        locale: mobiscroll.localeKo,
        buttons: [],  // 설정 버튼 제거
    });

    $('#tabButtons .btn').on('click', function () {
        currentTab = $(this).data('value');
        setActiveTabStyle();
        loadTable();
    });

    $('#find-user-search-btn').on('click', search);
    $('#deposit-submit').on('click', depositSubmit);

    // 목록 안의 링크·버튼 — 표를 다시 그려도 살도록 위임
    $('#table').on('click', '[data-sr="userCash"]', function (e) {
        e.preventDefault();
        $j.F.Admin.Util.userCash(String(this.dataset.n));
    });
    $('#table').on('click', '.btn-deposit', function () {
        depositModal(Number(this.dataset.num), Number(this.dataset.price), this.dataset.who);
    });

    // 입력 필드와 리스트를 제어할 인스턴스 생성
    $j.F.Admin.AutoComplete.init({id:'find-user-kwd'});
    $j.F.Admin.AutoComplete.init({id:'user-kwd'});
}

/**
 * 테이블 내용 불러오기
 */
function loadTable() {
    const columns = [
        {data: 'num', title: 'No', width: '50px'},
        {data: 'phone', title: '전화번호', width: '120px',
            render: function(data) {
                return $j.Common.Util.phoneNumber(data);
            }
        },
        {data: 'type', title: '분류', width: '60px',
            render: function(data, type, row) {
                return tabMsgMap[data];
            }
        },
        {data: 'message', title: '내용', width: '*',
            render: function(data, type, row) {
                return highlightBankSMS(data);
            }
        },
        {data: 'mem_name', title: '입금자', width: '80px',
            render: function(data, type, row) {
                if(row.type!=1 || !row.mb_no) return '';

                // 이름 = 캐시창(그대로) · #번호 = 회원 팝오버
                return `<a href="#" data-sr="userCash" data-n="${row.mb_no}">${row.mem_name}</a>`
                     + `<small class="text-muted">#${$j.F.Admin.Member.Pop.cellNo(row.mb_no)}</small>`;
            }
        },
        {data: 'manage_name', title: '처리자', width: '80px',
            render: function(data, type, row) {
                if(data) return data;
                else{
                    if(row.type!=1) return '';
                    const info = parseMessage(row.message);
                    if(!info) return '';
                    let price = info.price;
                    if (price.includes(',')) price = parseFloat(price.replace(/,/g, ''));
                    return `<button type="button" class="btn-deposit" data-num="${row.num}" data-price="${price}"`
                         + ` data-who="${$('<div>').text(info.who).html().replace(/"/g, '&quot;')}">처리</button>`;
                }
            }
        },
        {data: 'datetime', title: '처리시간', width: '180px',
            render: function(data) {
                return $j.Common.Util.formatDateTime(data);
            }
        },
        {data: 'created_at', title: '수신시간', width: '180px',
            render: function(data) {
                return $j.Common.Util.formatDateTime(data);
            }
        },
    ];
    
    if(currentTab!=1) {
        columns.splice(4, 1); // Remove mem_name column
        columns.splice(4, 1); // Remove mem_name column
        columns.splice(4, 1); // Remove mem_name column
    }


    if ($table) {
        $table.destroy();
        $('#table').empty();
    }

    $table = new DataTable('#table', {
        columns: columns,
        // rowCallback: formatRow,
        headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
        ajax: {
            url: '/adm/ajax/sms-recv/list',
            type: 'post',
            data: (d) => {
                d.findUserKwd = $('#find-user-kwd').val();
                d.type = currentTab;
                d.start_date = $('#start_date').val();
                d.end_date = $('#end_date').val();
            },
        },
        processing: true,
        serverSide: true,
        ordering: false,
        displayLength: 20,
        lengthChange: false,
        searching: false
    });
}

/**
 * 문자 내용에서 금액을 추출한다.
 * @param message
 * @returns {*|number}
 */
function parseMessage(message) {
    const regex = /\[KB\](\d{2}\/\d{2}\s+\d{2}:\d{2})\s+[0-9*]{6,}\s+(\S+)\s+(입금|출금)\s+([\d,]+)\s+잔액/;
    const match = message.match(regex);
    if (!match) return null;

    // 1) 거래시간
    const time = match[1];

    // 2) 구분
    const type = match[3];

    // 3) 금액
    let price = match[4];

    // 4) 예금주 부분
    const removeList = ['환불', '회비선결제','추가등록비'];// 제거할 키워드 배열
    let who = match[2];
    removeList.forEach(word => {// 배열에 있는 문자열들을 순회하며 제거
        const regex = new RegExp(word, "g");// 정규식을 이용해 해당 단어를 모두 제거 (공백 포함 정리)
        who = who.replace(regex, "");
    });
    who = who.replace(/\s+/g, " ").trim();// 연속된 공백 정리 및 앞뒤 공백 제거

    const data = {
        time,
        price,
        type,
        who,
    }
    return data;
}

/**
 * 문자 내용에서 예금주를 파란색, 금액을 빨간색으로 치환하는 함수
 * @param {string} message - 문자 내용
 * @returns {string}
 */
function highlightBankSMS(message) {
    const info = parseMessage(message);
    if (!info) return message;
    let price = info.price;
    let type = info.type;
    const amountCls = (type == '출금') ? 'sr-hl-out' : 'sr-hl-in';
    let time = info.time;
    let who = info.who;
    // "잔액"부터 이후 문자 제거
    message = message.replace(/잔액.*$/, '');
    // 예금주와 금액에 색상 적용
    let highlighted = message
        .replace(time, `&nbsp;&nbsp;<span class="sr-hl-time">${time}</span>&nbsp;&nbsp;`)
        .replace(who, `&nbsp;&nbsp;<span class="sr-hl-who">${who}</span>&nbsp;&nbsp;`)
        .replace(price, `&nbsp;&nbsp;<span class="${amountCls}">${price}</span>&nbsp;&nbsp;`);

    return highlighted;
}
/**
 * 탭 전환 시
 * @param tab 현재 탭 상태
 */
function switchTab(tab) {
    currentTab = tab;
    setActiveTabStyle();
    loadTable();
}

/**
 * 각 탭에 따른 클래스
 */
function setActiveTabStyle() {
    $('#tabButtons .btn').each(function () {
        const $btn = $(this);
        const tab = $btn.data('value');
        if (tab === currentTab) {
            $btn.addClass('active');
        } else {
            $btn.removeClass('active');
        }
    })
}

function search(){
    loadTable();
}

/**
 * 충전 처리 모달 띄우기
 * @param num
 * @param price
 */
function depositModal(num, price, who){
    $('#edit-modal').modal(); // 부트스트랩 모달
    $('#sms-num').val(num);
    $('#deposit-price').val($j.Common.Util.formatNumber(price));
    $('#user-kwd').val('').data('value', '');
    $('#bank-name').val(`${who}`);
}

/**
 * 충전 처리
 */
function depositSubmit(){
    const data = {
        num: $('#sms-num').val(),
        price: $('#deposit-price').val().replace(/,/g, ''),
        mb_no: $('#user-kwd').data('value'),
    };
    if( !data.num || !data.price || !data.mb_no ) {
        $j.F.Admin.Util.tsalert('warning', '필수항목이 채워지지 않았습니다.');
        return;
    }

    $.ajax({
        type: 'POST',
        data: data,
        url: `/adm/ajax/sms-recv/deposit`,
        success: function (r) {
            $('#edit-modal').modal('hide');
            $j.F.Admin.Util.tsalert('success', '캐시 충전이 완료되었습니다.');
            loadTable();
        }
    });
}
